var _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "map-background",
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse",
    patternContentUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "pattern-circle",
    cx: 5,
    cy: 5,
    r: 4
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "map-background-hovered",
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse",
    patternContentUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "pattern-circle-hovered",
    cx: 5,
    cy: 5,
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBackground);
export default __webpack_public_path__ + "static/media/map-background.55602a18.svg";
export { ForwardRef as ReactComponent };